<div>
    <div class="right-container">
        <mat-drawer-container class="menu-container" autosize>
            <mat-drawer #drawer class="menu-sidenav d-sm-block " mode="side" opened>
                <div class="container">
                    <div class="row">
                        <p class="logo header">PORTFOLIO</p>
                    </div>
                    <div class="menu-sidenav-items">
                        <div class="row menu-sidenav-item"
                            [ngClass]="currentURL === '/' + DPO_CONSTANT.PATH_SUBSCRIPTION ? 'menu-sidenav-item-hover' : ''"
                            *ngIf="isSubscriptionAccessible">
                            <a [routerLink]="['/' + DPO_CONSTANT.PATH_SUBSCRIPTION]" class="col">
                                <div>
                                    <mat-icon svgIcon="assignment"></mat-icon>
                                </div>
                                <span
                                    class="d-none d-sm-none d-md-block">{{'dpo.i18n.panel.subscription' | translate}}</span>
                            </a>
                        </div>
                        <div class="row menu-sidenav-item"
                            [ngClass]="currentURL === '/' + DPO_CONSTANT.PATH_CONSULTATION ? 'menu-sidenav-item-hover' : ''"
                            *ngIf="isConsultationAccessible">
                            <a [routerLink]="['/' + DPO_CONSTANT.PATH_CONSULTATION]" class="col">
                                <div>
                                    <mat-icon svgIcon="group"></mat-icon>
                                </div>
                                <span
                                    class="d-none d-sm-none d-md-block">{{'dpo.i18n.panel.consultation' | translate}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </mat-drawer>
            <div class="menu-sidenav-content">
                <div class="header">
                    <button class="menu-toggle-button" type="button" mat-button (click)="drawer.toggle()">
                        <mat-icon svgIcon="menu"></mat-icon>
                    </button>
                    <div class="header-items">
                        <div class="container">
                            <div class="row justify-content-end">
                                <div class="language-select">
                                    <div class="d-none d-sm-block col-sm-5 label">
                                        {{'dpo.i18n.header.language' | translate}}
                                    </div>
                                    <select class="col-12 col-sm-7 input field"
                                        (change)="changeLocale($event.target.value)" [(ngModel)]="locale">
                                        <!-- CountryName is replaced with Country Language -->
                                        <option *ngFor="let language of languages" value="{{language.languageCode}}">{{language.language}}</option>
                                    </select>
                                </div>
                                <div class="col-auto">
                                    <div class="logout">
                                        <mat-icon (click)="logout()" svgIcon="power_settings"></mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contant-container">
                    <router-outlet name="panel"></router-outlet>
                </div>
            </div>
        </mat-drawer-container>
    </div>
</div>